import axios from 'axios'
import {
    ConfigurationPersonnelWeekdayAssignmentCreateRequest,
    ConfigurationPersonnelWeekdayAssignmentResponse
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-weekday-assignment/configuration-personnel-weekday-assignment.dto'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'

class ConfigurationPersonnelWeekdayAssignmentService {
    async create(laboratoryId: number, request: ConfigurationPersonnelWeekdayAssignmentCreateRequest): Promise<ConfigurationPersonnelWeekdayAssignmentResponse> {
        const response = await axios.post<ConfigurationPersonnelWeekdayAssignmentResponse>(`/configuration/laboratories/${laboratoryId}/personnelWeekdayAssignments`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationPersonnelWeekdayAssignmentResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationPersonnelWeekdayAssignmentResponse>>(`/configuration/laboratories/${laboratoryId}/personnelWeekdayAssignments`, { ...filterModel }, { params })
        return response.data
    }

    async delete(personnelWeekdayAssignmentId: number, laboratoryId: number): Promise<void> {
        const response = await axios.delete<void>(`/configuration/laboratories/${laboratoryId}/personnelWeekdayAssignments/${personnelWeekdayAssignmentId}`)
        return response.data
    }
}

export const configurationPersonnelWeekdayAssignmentService = new ConfigurationPersonnelWeekdayAssignmentService()
